export default __webpack_public_path__ + "static/media/ArrowRight.12633188.svg";